export enum LengthMetricType {
  CM = 'CM',
  INCH = 'INCH'
}

export enum WeightMetricType {
  KG = 'KG',
  LB = 'LB'
}
